import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicNavbar from "../components/layout/PublicNavbar";
import Footer from "../components/layout/Footer";
import Seo from "../components/Seo";
import api from "../lib/api";

// Curated static insights shown as a fallback + evergreen tiles.
const CURATED = [
  { t: "The state of Indian family office allocations, 2026", tag: "Insight", read: "8 min" },
  { t: "Why NBFCs are the fastest debt path for CleanTech scale-ups", tag: "Debt", read: "6 min" },
  { t: "How to prepare a Series A data room in 21 days", tag: "Playbook", read: "12 min" },
  { t: "VenturaZ quarterly deal-flow report — Q1", tag: "Report", read: "18 min" },
];

export default function Resources() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blogs?limit=24")
      .then((r) => setPosts(r.data?.items || []))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-cream text-ink" data-testid="resources-page">
      <Seo
        title="Resources & Guides | VenturaZ"
        description="Fundraising playbooks, due diligence checklists, sector deep-dives and investor readiness guides — refreshed weekly by the VenturaZ editorial engine."
        keywords="fundraising playbook, due diligence checklist, private capital, VenturaZ resources, startup guides, investor readiness"
        path="/resources"
      />
      <PublicNavbar />
      <main>
        <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
          <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-gold mb-3">RESOURCES</div>
          <h1 className="font-display text-4xl lg:text-6xl text-ink leading-tight max-w-3xl">
            Insight, playbooks, and market reports.
          </h1>
          <p className="mt-4 text-ink-soft max-w-2xl">
            Refreshed weekly. VenturaZ blends editorial insight with sector-trend data so founders and investors
            walk in prepared.
          </p>

          {loading ? (
            <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-4">
              {[0, 1, 2, 3].map((i) => (
                <div key={i} className="border border-navy/10 bg-white/70 backdrop-blur p-6 animate-pulse h-40" />
              ))}
            </div>
          ) : (
            <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-4">
              {posts.map((p) => (
                <Link
                  key={p.slug}
                  to={`/resources/${p.slug}`}
                  className="border border-navy/10 bg-white/70 backdrop-blur p-6 hover:border-gold/40 transition-colors block"
                  data-testid={`blog-card-${p.slug}`}
                >
                  <div className="flex items-center justify-between mb-3">
                    <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-emerald-800">{p.tag || "Insight"}</div>
                    <div className="text-xs font-mono text-ink-faint">{p.read_minutes || 6} min</div>
                  </div>
                  <div className="font-heading text-ink text-lg leading-snug">{p.title}</div>
                  {p.excerpt && (
                    <p className="mt-2 text-sm text-ink-soft line-clamp-3">{p.excerpt}</p>
                  )}
                  <div className="mt-6 text-gold text-sm font-heading">Read →</div>
                </Link>
              ))}
              {posts.length === 0 && CURATED.map((i) => (
                <div key={i.t} className="border border-navy/10 bg-white/70 backdrop-blur p-6"
                     data-testid="blog-card-curated">
                  <div className="flex items-center justify-between mb-3">
                    <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-emerald-800">{i.tag}</div>
                    <div className="text-xs font-mono text-ink-faint">{i.read}</div>
                  </div>
                  <div className="font-heading text-ink text-lg leading-snug">{i.t}</div>
                  <div className="mt-6 text-gold text-sm font-heading">Coming soon →</div>
                </div>
              ))}
            </div>
          )}
        </section>
      </main>
      <Footer />
    </div>
  );
}
